import borderRadius from 'src/theme/core/borderRadius'
import { lineHeight } from 'suneditor/src/plugins'

const styles = theme => ({
  fixedButtonContainer: {
    padding: '6px',
    width: '62px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '12px',
    position: 'fixed',
    right: '20px',
    top: '50%',
    transform: 'translateY(-50%)',
    alignıtems: 'flex-end',
    zIndex: 1000,
    backgroundColor: '#F4F6F8',
    gap: '12px',
  },

  fixedButton: {
    display: 'flex',
    gap: '6px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    width: '50px !important',
    height: '56px !important',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: 'white',
    },
  },
  active: {
    cursor: 'pointer',
    backgroundColor: 'white',
  },
  iconContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: '#002E47',
  },
  label: {
    fontSize: '11px',
    fontWeight: '400',
    lineHeight: 'normal',
    marginTop: '2px',
  },

  optionsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '12px',
  },
  dropdownContainer: {
    position: 'fixed',
    right: '91px',
    top: '50%',
    padding: '0px 12px 12px 12px',
    width: '208px',
    height: '648px',
    backgroundColor: '#F4F6F8',
    transform: 'translateY(-50%)',
    borderRadius: '12px',
    zIndex: 11010,
    color: '#002E47',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    overflow: 'hidden',
    '&:hover': {
      overflow: 'auto',
      overflowY: 'scroll',
      overflowX: 'hidden',
    },
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#F4F6F8',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#CBD5E0',
      borderRadius: '4px',
      '&:hover': {
        background: '#A0AEC0',
      },
    },
    '&::-webkit-scrollbar-track-piece:start': {
      backgroundColor: 'transparent', // Make top transparent
      marginTop: '16px',
    },
    '&::-webkit-scrollbar-track-piece:end': {
      backgroundColor: 'transparent', // Make bottom transparent
      marginBottom: '16px',
    },
  },
  CKEditor: {
    width: '100%',
    height: 'auto',
    textAlign: 'center',
    margin: '0 auto',
  },
  withDivider: {
    paddingTop: '12px',
    borderBottom: '1px solid #e0e0e0',
    paddingTop: '12px',
  },
  withDividerEmbed: {
    borderBottom: '1px solid #e0e0e0',
  },
  dropdownHeader: {
    paddingTop: '12px',
    paddingBottom: '4px',
    width: '186px',
    position: 'sticky',
    top: '0',
    zIndex: '1' /* Ensure the header is on top of the content */,
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#F4F6F8',
    alignItems: 'center',
  },

  iconButton: {
    width: '16px',
    minWidth: '16px',
    height: '16px',
  },
  icon: {
    cursor: 'pointer',
  },

  optionEmbedContainer: {
    width: '88px',
    height: '88px',
    cursor: 'pointer',
    borderRadius: '6px',
    overflow: 'hidden',
    border: '1px solid white',
    backgroundColor: 'white',
    position: 'relative',
    '&:hover': {
      border: '1px solid #015FFB',
    },
  },
  optionEmbedContainerDisabled: {
    width: '88px',
    height: '88px',
    cursor: 'not-allowed',
    borderRadius: '6px',
    overflow: 'hidden',
    border: '1px solid white',
    backgroundColor: 'white',
    position: 'relative',
    pointerEvents: 'none',
    '&:hover': {
      border: '1px solid white',
    },
  },

  optionContainer: {
    width: '186px',
    height: '92px',
    cursor: 'pointer',
    borderRadius: '6px',
    border: '1px solid white',
    backgroundColor: 'white',
    position: 'relative',
    '&:hover': {
      border: '1px solid #015FFB',
    },
  },
  optionContainerDisabled: {
    width: '186px',
    height: '92px',
    cursor: 'not-allowed',
    borderRadius: '6px',
    border: '1px solid white',
    backgroundColor: 'white',
    position: 'relative',
    pointerEvents: 'none',
    '&:hover': {
      border: '1px solid white',
    },
  },
  optionContainerSoon: {
    width: '88px',
    height: '88px',
    cursor: 'not-allowed',
    borderRadius: '6px',
    overflow: 'hidden',
    border: '1px solid white',
    backgroundColor: 'white',
    position: 'relative',
    pointerEvents: 'none',
    '&:hover': {
      border: '1px solid white',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    paddingTop: '18px',
    paddingBottom: '12px',
  },
  containerEmbed: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '6px',
    paddingBottom: '12px',
    paddingTop: '6px',
    width: '88px',
  },

  optionTitle: {
    fontWeight: 400,
    fontSize: '10px',
    textAlign: 'center',
    width: '184px',
  },
  optionTitleEmbed: {
    fontWeight: 400, // Regular weight
    fontSize: '10px',
    textAlign: 'center',
  },

  optionHeading: {
    fontSize: '12px',
    color: 'rgba(0, 0, 0, 0.7)',
    marginBottom: '4px',
  },

  image: {
    width: '184px',
    height: '90px',
    borderRadius: '6px',
    userSelect: 'none',
    pointerEvents: 'none',
  },
  imageEmbed: {
    width: '86px',
    height: '86px',
    userSelect: 'none',
    pointerEvents: 'none',
  },
  proBadgeContainer: {
    position: 'absolute',
    top: '0',
    right: '8px',
    zIndex: 10,
    cursor: 'pointer',
    pointerEvents: 'auto',
    '&:hover': {
      opacity: 0.9,
    },
  },
  disabledContainer: {
    position: 'relative',
    opacity: 0.5,
    cursor: 'not-allowed',
    pointerEvents: 'none',
  },
  subcategoriesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  subcategorySection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  subcategoryHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '10px',
    fontWeight: 500,
    color: 'rgba(0, 46, 71, 0.6)',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    paddingTop: '12px',
  },
  subcategoryIndicator: {
    width: '2px',
    height: '12px',
    borderRadius: '50px',
    flexShrink: 0,
  },
  subcategoryOptionsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 88px)',
    gap: '8px 12px',
    justifyContent: 'flex-start',
  },
})

export default styles
